import React from 'react';

export default function Icon({ name, size = 22, style: extra = {}, ...rest }) {
  return (
    <span
      className="material-symbols-outlined"
      style={{ fontSize: size, lineHeight: 1, ...extra }}
      {...rest}
    >
      {name}
    </span>
  );
}
